import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from '../AfterSalesWarning.styles';
import { CancelButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';

const ChildrenWillTravelAloneWarning = ({ isOpen, closeModal }) => (
  <Modal
    isOpen={isOpen}
    title={<FormattedMessage id="searchResults.cannotBeBooked" />}
    subtitle={<FormattedMessage id="aftersalesWarning.childrenWillTravelAlone" />}
    onClose={closeModal}
  >
    <Row>
      <StyledColumn span={3}>
        <CancelButton data-cy="cancel" onClick={closeModal}>
          <FormattedMessage id="manageBooking.cancel" />
        </CancelButton>
      </StyledColumn>
    </Row>
  </Modal>
);

ChildrenWillTravelAloneWarning.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func
};

export default ChildrenWillTravelAloneWarning;
